import { Commodity, CommodityCategory, PreciousMetalsSubcategory, EnergySubcategory, IndustrialMetalsSubcategory, AgriculturalSubcategory, NewsArticle } from '@/types';

/**
 * Mock commodity data for development
 */
export const MOCK_COMMODITIES: Commodity[] = [
    // Precious Metals - Core (핵심 귀금속)
    {
        id: '1',
        symbol: 'XAUUSD',
        name: 'Gold',
        nameKo: '금',
        category: CommodityCategory.PRECIOUS_METALS,
        subcategory: PreciousMetalsSubcategory.CORE,
        currentPrice: 4532.20,
        currency: 'USD',
        change: 45.30,
        changePercent: 1.01,
        lastUpdated: new Date(),
        icon: '🥇',
    },
    {
        id: '2',
        symbol: 'XAGUSD',
        name: 'Silver',
        nameKo: '은',
        category: CommodityCategory.PRECIOUS_METALS,
        subcategory: PreciousMetalsSubcategory.CORE,
        currentPrice: 79.11,
        currency: 'USD',
        change: 1.25,
        changePercent: 1.60,
        lastUpdated: new Date(),
        icon: '🥈',
    },
    {
        id: '3',
        symbol: 'XPTUSD',
        name: 'Platinum',
        nameKo: '백금',
        category: CommodityCategory.PRECIOUS_METALS,
        subcategory: PreciousMetalsSubcategory.PGM_SPECIALTY,
        currentPrice: 1150.00,
        currency: 'USD',
        change: 15.50,
        changePercent: 1.35,
        lastUpdated: new Date(),
        icon: '⚪',
    },
    // Energy - Crude Oil (원유)
    {
        id: '4',
        symbol: 'CL=F',
        name: 'Crude Oil WTI',
        nameKo: 'WTI 원유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 56.74,
        currency: 'USD',
        change: -0.85,
        changePercent: -1.48,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '5',
        symbol: 'BZ=F',
        name: 'Brent Crude',
        nameKo: '브렌트유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 60.50,
        currency: 'USD',
        change: -0.90,
        changePercent: -1.45,
        lastUpdated: new Date(),
        icon: '⛽',
    },
    {
        id: '6',
        symbol: 'DUBAI',
        name: 'Dubai',
        nameKo: '두바이유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 58.20,
        currency: 'USD',
        change: -0.75,
        changePercent: -1.27,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '7',
        symbol: 'OMAN',
        name: 'Oman',
        nameKo: '오만유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 58.80,
        currency: 'USD',
        change: -0.80,
        changePercent: -1.34,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '8',
        symbol: 'MURBAN',
        name: 'Murban',
        nameKo: '무르반유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 59.10,
        currency: 'USD',
        change: -0.85,
        changePercent: -1.42,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '9',
        symbol: 'TAPIS',
        name: 'Tapis',
        nameKo: '타피스유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 62.30,
        currency: 'USD',
        change: -0.95,
        changePercent: -1.50,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '10',
        symbol: 'BONNY',
        name: 'Bonny Light',
        nameKo: '보니라이트유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 61.50,
        currency: 'USD',
        change: -0.88,
        changePercent: -1.41,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '11',
        symbol: 'LSC',
        name: 'Light Sweet Crude',
        nameKo: '경질 저유황 원유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 57.20,
        currency: 'USD',
        change: -0.82,
        changePercent: -1.41,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '12',
        symbol: 'HEAVY',
        name: 'Heavy Crude',
        nameKo: '중질유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 52.30,
        currency: 'USD',
        change: -0.70,
        changePercent: -1.32,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    {
        id: '13',
        symbol: 'SOUR',
        name: 'Sour Crude',
        nameKo: '고유황 원유',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.CRUDE_OIL,
        currentPrice: 54.10,
        currency: 'USD',
        change: -0.75,
        changePercent: -1.37,
        lastUpdated: new Date(),
        icon: '🛢️',
    },
    // Energy - Gas (가스 에너지)
    {
        id: '14',
        symbol: 'NG=F',
        name: 'Natural Gas',
        nameKo: '천연가스',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 3.85,
        currency: 'USD',
        change: 0.12,
        changePercent: 3.22,
        lastUpdated: new Date(),
        icon: '🔥',
    },
    {
        id: '15',
        symbol: 'HH',
        name: 'Henry Hub',
        nameKo: '헨리허브 천연가스',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 3.92,
        currency: 'USD',
        change: 0.15,
        changePercent: 3.98,
        lastUpdated: new Date(),
        icon: '🔥',
    },
    {
        id: '16',
        symbol: 'TTF',
        name: 'TTF (Title Transfer Facility)',
        nameKo: '유럽 TTF 가스',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 45.50,
        currency: 'USD',
        change: 1.85,
        changePercent: 4.24,
        lastUpdated: new Date(),
        icon: '🔥',
    },
    {
        id: '17',
        symbol: 'NBP',
        name: 'NBP (National Balancing Point)',
        nameKo: '영국 NBP 가스',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 44.20,
        currency: 'USD',
        change: 1.75,
        changePercent: 4.12,
        lastUpdated: new Date(),
        icon: '🔥',
    },
    {
        id: '18',
        symbol: 'LNG',
        name: 'LNG',
        nameKo: '액화천연가스',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 18.50,
        currency: 'USD',
        change: 0.85,
        changePercent: 4.82,
        lastUpdated: new Date(),
        icon: '❄️',
    },
    {
        id: '19',
        symbol: 'LNG_SPOT',
        name: 'LNG Spot',
        nameKo: 'LNG 현물',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 19.80,
        currency: 'USD',
        change: 0.95,
        changePercent: 5.04,
        lastUpdated: new Date(),
        icon: '❄️',
    },
    {
        id: '20',
        symbol: 'LNG_LT',
        name: 'LNG Long-term Contract',
        nameKo: 'LNG 장기계약 가격',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 16.20,
        currency: 'USD',
        change: 0.50,
        changePercent: 3.18,
        lastUpdated: new Date(),
        icon: '❄️',
    },
    {
        id: '21',
        symbol: 'JKM',
        name: 'JKM (Japan Korea Marker)',
        nameKo: 'JKM (한·일 LNG 기준가)',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 19.50,
        currency: 'USD',
        change: 0.88,
        changePercent: 4.73,
        lastUpdated: new Date(),
        icon: '❄️',
    },
    {
        id: '22',
        symbol: 'LPG',
        name: 'LPG',
        nameKo: '액화석유가스',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 625.00,
        currency: 'USD',
        change: 12.50,
        changePercent: 2.04,
        lastUpdated: new Date(),
        icon: '⛽',
    },
    {
        id: '23',
        symbol: 'PROPANE',
        name: 'Propane',
        nameKo: '프로판',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 0.85,
        currency: 'USD',
        change: 0.02,
        changePercent: 2.41,
        lastUpdated: new Date(),
        icon: '⛽',
    },
    {
        id: '24',
        symbol: 'BUTANE',
        name: 'Butane',
        nameKo: '부탄',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.GAS,
        currentPrice: 0.92,
        currency: 'USD',
        change: -0.03,
        changePercent: -3.16,
        lastUpdated: new Date(),
        icon: '⛽',
    },
    // Energy - Electricity (전력)
    {
        id: '25',
        symbol: 'ELEC',
        name: 'Electricity',
        nameKo: '전력',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.ELECTRICITY,
        currentPrice: 85.50,
        currency: 'USD',
        change: 3.25,
        changePercent: 3.95,
        lastUpdated: new Date(),
        icon: '⚡',
    },
    {
        id: '26',
        symbol: 'BASE_POWER',
        name: 'Base Load Power',
        nameKo: '기저부하 전력',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.ELECTRICITY,
        currentPrice: 75.25,
        currency: 'USD',
        change: 2.15,
        changePercent: 2.94,
        lastUpdated: new Date(),
        icon: '⚡',
    },
    {
        id: '27',
        symbol: 'PEAK_POWER',
        name: 'Peak Load Power',
        nameKo: '최대부하 전력',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.ELECTRICITY,
        currentPrice: 125.75,
        currency: 'USD',
        change: 5.50,
        changePercent: 4.57,
        lastUpdated: new Date(),
        icon: '⚡',
    },
    {
        id: '28',
        symbol: 'REGIONAL_POWER',
        name: 'Regional Power Prices',
        nameKo: '지역별 전력 가격',
        category: CommodityCategory.ENERGY,
        subcategory: EnergySubcategory.ELECTRICITY,
        currentPrice: 92.30,
        currency: 'USD',
        change: -1.85,
        changePercent: -1.96,
        lastUpdated: new Date(),
        icon: '⚡',
    },
    // Agriculture - Grains (곡물)
    {
        id: '29',
        symbol: 'ZC=F',
        name: 'Corn',
        nameKo: '옥수수',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.GRAINS,
        currentPrice: 485.25,
        currency: 'USD',
        change: 3.75,
        changePercent: 0.78,
        lastUpdated: new Date(),
        icon: '🌽',
    },
    {
        id: '30',
        symbol: 'ZW=F',
        name: 'Wheat',
        nameKo: '밀',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.GRAINS,
        currentPrice: 625.50,
        currency: 'USD',
        change: -8.25,
        changePercent: -1.30,
        lastUpdated: new Date(),
        icon: '🌾',
    },
    {
        id: '31',
        symbol: 'ZO=F',
        name: 'Oats',
        nameKo: '오트',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.GRAINS,
        currentPrice: 385.75,
        currency: 'USD',
        change: 2.50,
        changePercent: 0.65,
        lastUpdated: new Date(),
        icon: '🌾',
    },
    {
        id: '32',
        symbol: 'ZR=F',
        name: 'Rice',
        nameKo: '쌀',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.GRAINS,
        currentPrice: 16.75,
        currency: 'USD',
        change: 0.25,
        changePercent: 1.52,
        lastUpdated: new Date(),
        icon: '🍚',
    },
    {
        id: '33',
        symbol: 'BARLEY',
        name: 'Barley',
        nameKo: '보리',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.GRAINS,
        currentPrice: 245.30,
        currency: 'USD',
        change: -3.20,
        changePercent: -1.29,
        lastUpdated: new Date(),
        icon: '🌾',
    },
    {
        id: '34',
        symbol: 'SORGHUM',
        name: 'Sorghum',
        nameKo: '수수',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.GRAINS,
        currentPrice: 425.60,
        currency: 'USD',
        change: 5.40,
        changePercent: 1.28,
        lastUpdated: new Date(),
        icon: '🌾',
    },
    // Agriculture - Oilseeds & Oils (유지종자 및 유지)
    {
        id: '35',
        symbol: 'ZS=F',
        name: 'Soybeans',
        nameKo: '대두',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.OILSEEDS,
        currentPrice: 1425.50,
        currency: 'USD',
        change: -12.25,
        changePercent: -0.85,
        lastUpdated: new Date(),
        icon: '🫘',
    },
    {
        id: '36',
        symbol: 'ZM=F',
        name: 'Soybean Meal',
        nameKo: '대두박',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.OILSEEDS,
        currentPrice: 425.80,
        currency: 'USD',
        change: 8.30,
        changePercent: 1.99,
        lastUpdated: new Date(),
        icon: '🫘',
    },
    {
        id: '37',
        symbol: 'ZL=F',
        name: 'Soybean Oil',
        nameKo: '대두유',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.OILSEEDS,
        currentPrice: 52.45,
        currency: 'USD',
        change: -0.85,
        changePercent: -1.59,
        lastUpdated: new Date(),
        icon: '🫘',
    },
    {
        id: '38',
        symbol: 'RS=F',
        name: 'Canola',
        nameKo: '카놀라',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.OILSEEDS,
        currentPrice: 432.50,
        currency: 'USD',
        change: 9.25,
        changePercent: 2.18,
        lastUpdated: new Date(),
        icon: '🌻',
    },
    {
        id: '39',
        symbol: 'SUNFLOWER',
        name: 'Sunflower Seeds',
        nameKo: '해바라기씨',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.OILSEEDS,
        currentPrice: 625.00,
        currency: 'USD',
        change: -5.75,
        changePercent: -0.91,
        lastUpdated: new Date(),
        icon: '🌻',
    },
    {
        id: '40',
        symbol: 'PALM',
        name: 'Palm Oil',
        nameKo: '팜유',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.OILSEEDS,
        currentPrice: 950.00,
        currency: 'USD',
        change: 19.00,
        changePercent: 2.04,
        lastUpdated: new Date(),
        icon: '🌴',
    },
    // Agriculture - Soft Commodities (가공 식품/기호 농산물)
    {
        id: '41',
        symbol: 'KC=F',
        name: 'Coffee',
        nameKo: '커피',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SOFT_COMMODITIES,
        currentPrice: 185.40,
        currency: 'USD',
        change: 4.20,
        changePercent: 2.32,
        lastUpdated: new Date(),
        icon: '☕',
    },
    {
        id: '42',
        symbol: 'SB=F',
        name: 'Sugar',
        nameKo: '설탕',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SOFT_COMMODITIES,
        currentPrice: 24.35,
        currency: 'USD',
        change: 0.45,
        changePercent: 1.88,
        lastUpdated: new Date(),
        icon: '🍬',
    },
    {
        id: '43',
        symbol: 'CC=F',
        name: 'Cocoa',
        nameKo: '코코아',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SOFT_COMMODITIES,
        currentPrice: 4250.00,
        currency: 'USD',
        change: 85.00,
        changePercent: 2.04,
        lastUpdated: new Date(),
        icon: '🍫',
    },
    {
        id: '44',
        symbol: 'OJ=F',
        name: 'Orange Juice',
        nameKo: '오렌지 주스',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SOFT_COMMODITIES,
        currentPrice: 285.50,
        currency: 'USD',
        change: -5.25,
        changePercent: -1.81,
        lastUpdated: new Date(),
        icon: '🍊',
    },
    {
        id: '45',
        symbol: 'CT=F',
        name: 'Cotton',
        nameKo: '면화',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SOFT_COMMODITIES,
        currentPrice: 82.15,
        currency: 'USD',
        change: -1.20,
        changePercent: -1.44,
        lastUpdated: new Date(),
        icon: '🌾',
    },
    // Agriculture - Livestock (축산물)
    {
        id: '46',
        symbol: 'LE=F',
        name: 'Live Cattle',
        nameKo: '생우',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.LIVESTOCK,
        currentPrice: 175.50,
        currency: 'USD',
        change: 2.25,
        changePercent: 1.30,
        lastUpdated: new Date(),
        icon: '🐄',
    },
    {
        id: '47',
        symbol: 'GF=F',
        name: 'Feeder Cattle',
        nameKo: '사육우',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.LIVESTOCK,
        currentPrice: 245.75,
        currency: 'USD',
        change: -3.50,
        changePercent: -1.40,
        lastUpdated: new Date(),
        icon: '🐄',
    },
    {
        id: '48',
        symbol: 'HE=F',
        name: 'Lean Hogs',
        nameKo: '돼지',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.LIVESTOCK,
        currentPrice: 78.90,
        currency: 'USD',
        change: 1.85,
        changePercent: 2.40,
        lastUpdated: new Date(),
        icon: '🐷',
    },
    // Agriculture - Dairy (유제품)
    {
        id: '49',
        symbol: 'DC=F',
        name: 'Milk',
        nameKo: '우유',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.DAIRY,
        currentPrice: 18.45,
        currency: 'USD',
        change: 0.35,
        changePercent: 1.93,
        lastUpdated: new Date(),
        icon: '🥛',
    },
    {
        id: '50',
        symbol: 'CSC=F',
        name: 'Cheese',
        nameKo: '치즈',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.DAIRY,
        currentPrice: 1.85,
        currency: 'USD',
        change: -0.05,
        changePercent: -2.63,
        lastUpdated: new Date(),
        icon: '🧀',
    },
    {
        id: '51',
        symbol: 'CB=F',
        name: 'Butter',
        nameKo: '버터',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.DAIRY,
        currentPrice: 2.95,
        currency: 'USD',
        change: 0.08,
        changePercent: 2.79,
        lastUpdated: new Date(),
        icon: '🧈',
    },
    // Agriculture - Other Specialty Crops (기타 특수 농산물)
    {
        id: '52',
        symbol: 'ADZUKI',
        name: 'Adzuki Beans',
        nameKo: '팥',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SPECIALTY,
        currentPrice: 12.75,
        currency: 'USD',
        change: 0.17,
        changePercent: 1.37,
        lastUpdated: new Date(),
        icon: '🫘',
    },
    {
        id: '53',
        symbol: 'PEANUTS',
        name: 'Peanuts',
        nameKo: '땅콩',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SPECIALTY,
        currentPrice: 625.50,
        currency: 'USD',
        change: -8.50,
        changePercent: -1.34,
        lastUpdated: new Date(),
        icon: '🥜',
    },
    {
        id: '54',
        symbol: 'ALMONDS',
        name: 'Almonds',
        nameKo: '아몬드',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SPECIALTY,
        currentPrice: 2.85,
        currency: 'USD',
        change: 0.12,
        changePercent: 4.40,
        lastUpdated: new Date(),
        icon: '🌰',
    },
    {
        id: '55',
        symbol: 'CASHEWS',
        name: 'Cashews',
        nameKo: '캐슈넛',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SPECIALTY,
        currentPrice: 4.25,
        currency: 'USD',
        change: -0.15,
        changePercent: -3.41,
        lastUpdated: new Date(),
        icon: '🌰',
    },
    {
        id: '56',
        symbol: 'WALNUTS',
        name: 'Walnuts',
        nameKo: '호두',
        category: CommodityCategory.AGRICULTURE,
        subcategory: AgriculturalSubcategory.SPECIALTY,
        currentPrice: 3.15,
        currency: 'USD',
        change: 0.08,
        changePercent: 2.61,
        lastUpdated: new Date(),
        icon: '🌰',
    },
    // Industrial Metals - Base Metals (전통 산업금속)
    {
        id: '57',
        symbol: 'HG=F',
        name: 'Copper',
        nameKo: '구리',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.BASE_METALS,
        currentPrice: 3.85,
        currency: 'USD',
        change: 0.05,
        changePercent: 1.32,
        lastUpdated: new Date(),
        icon: '🔶',
    },
    {
        id: '58',
        symbol: 'ALI=F',
        name: 'Aluminum',
        nameKo: '알루미늄',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.BASE_METALS,
        currentPrice: 2245.00,
        currency: 'USD',
        change: -15.50,
        changePercent: -0.69,
        lastUpdated: new Date(),
        icon: '⚙️',
    },
    {
        id: '59',
        symbol: 'NI=F',
        name: 'Nickel',
        nameKo: '니켈',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.BATTERY_ENERGY,
        currentPrice: 16850.00,
        currency: 'USD',
        change: 125.00,
        changePercent: 0.75,
        lastUpdated: new Date(),
        icon: '🔩',
    },
    // Industrial Metals - Rare & Strategic Metals (희소·전략 금속)
    {
        id: '60',
        symbol: 'MOLY',
        name: 'Molybdenum',
        nameKo: '몰리브덴',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 45.50,
        currency: 'USD',
        change: 1.25,
        changePercent: 2.82,
        lastUpdated: new Date(),
        icon: '⚛️',
    },
    {
        id: '61',
        symbol: 'TUNGSTEN',
        name: 'Tungsten',
        nameKo: '텅스텐',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 285.00,
        currency: 'USD',
        change: -5.50,
        changePercent: -1.89,
        lastUpdated: new Date(),
        icon: '⚛️',
    },
    {
        id: '62',
        symbol: 'VANADIUM',
        name: 'Vanadium',
        nameKo: '바나듐',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 28.75,
        currency: 'USD',
        change: 0.85,
        changePercent: 3.05,
        lastUpdated: new Date(),
        icon: '⚛️',
    },
    {
        id: '63',
        symbol: 'ANTIMONY',
        name: 'Antimony',
        nameKo: '안티모니',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 11.25,
        currency: 'USD',
        change: -0.35,
        changePercent: -3.02,
        lastUpdated: new Date(),
        icon: '⚛️',
    },
    {
        id: '64',
        symbol: 'BISMUTH',
        name: 'Bismuth',
        nameKo: '비스무트',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 8.95,
        currency: 'USD',
        change: 0.15,
        changePercent: 1.70,
        lastUpdated: new Date(),
        icon: '⚛️',
    },
    // Industrial Metals - Rare Earth Elements (희토류)
    {
        id: '65',
        symbol: 'ND',
        name: 'Neodymium',
        nameKo: '네오디뮴',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 125.50,
        currency: 'USD',
        change: 3.75,
        changePercent: 3.08,
        lastUpdated: new Date(),
        icon: '🔬',
    },
    {
        id: '66',
        symbol: 'PR',
        name: 'Praseodymium',
        nameKo: '프라세오디뮴',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 115.25,
        currency: 'USD',
        change: 2.50,
        changePercent: 2.22,
        lastUpdated: new Date(),
        icon: '🔬',
    },
    {
        id: '67',
        symbol: 'DY',
        name: 'Dysprosium',
        nameKo: '디스프로슘',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 385.00,
        currency: 'USD',
        change: -8.50,
        changePercent: -2.16,
        lastUpdated: new Date(),
        icon: '🔬',
    },
    {
        id: '68',
        symbol: 'TB',
        name: 'Terbium',
        nameKo: '테르븀',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 1250.00,
        currency: 'USD',
        change: 25.00,
        changePercent: 2.04,
        lastUpdated: new Date(),
        icon: '🔬',
    },
    {
        id: '69',
        symbol: 'LA',
        name: 'Lanthanum',
        nameKo: '란타넘',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 5.85,
        currency: 'USD',
        change: 0.12,
        changePercent: 2.09,
        lastUpdated: new Date(),
        icon: '🔬',
    },
    {
        id: '70',
        symbol: 'CE',
        name: 'Cerium',
        nameKo: '세륨',
        category: CommodityCategory.INDUSTRIAL_METALS,
        subcategory: IndustrialMetalsSubcategory.RARE_STRATEGIC,
        currentPrice: 4.25,
        currency: 'USD',
        change: -0.08,
        changePercent: -1.85,
        lastUpdated: new Date(),
        icon: '🔬',
    },
];

/**
 * Category labels in Korean
 */
export const CATEGORY_LABELS: Record<CommodityCategory, string> = {
    [CommodityCategory.PRECIOUS_METALS]: '귀금속',
    [CommodityCategory.ENERGY]: '에너지',
    [CommodityCategory.AGRICULTURE]: '농산물',
    [CommodityCategory.INDUSTRIAL_METALS]: '산업금속',
};

/**
 * Timeframe options for charts
 */
export const TIMEFRAME_OPTIONS = [
    { value: '1D', label: '1일' },
    { value: '1W', label: '1주' },
    { value: '1M', label: '1개월' },
    { value: '3M', label: '3개월' },
    { value: '1Y', label: '1년' },
    { value: 'ALL', label: '전체' },
] as const;


/**
 * Mock news data for development
 */
export const MOCK_NEWS: NewsArticle[] = [
    {
        id: 'news-1',
        title: '금 가격, 사상 최고치 경신... 지정학적 리스크 확대',
        summary: '금 가격이 온스당 $4,500을 돌파하며 역대 최고가를 기록했습니다. 중동 긴장 고조와 미 연준의 금리 인하 기대감이 안전자산 수요를 증가시켰습니다.',
        url: 'https://example.com/news/gold-all-time-high',
        source: 'Bloomberg',
        publishedAt: new Date('2026-01-25T08:00:00'),
        relatedCommodities: ['1'], // Gold
        imageUrl: 'https://images.unsplash.com/photo-1610375461369-d1eb4f8c446f?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-2',
        title: '은 시장 급등세, 산업 수요 증가와 공급 부족 우려',
        summary: '은 가격이 온스당 $79를 돌파하며 10년 만에 최고치를 기록했습니다. 태양광 패널과 전기차 배터리 수요 급증이 주요 원인으로 분석됩니다.',
        url: 'https://example.com/news/silver-supply-shortage',
        source: 'Reuters',
        publishedAt: new Date('2026-01-24T14:30:00'),
        relatedCommodities: ['2'], // Silver
        imageUrl: 'https://images.unsplash.com/photo-1594980596870-0081324648e8?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-3',
        title: 'WTI 원유, 공급 과잉 우려로 $57선 하락',
        summary: 'OPEC+ 증산 결정과 글로벌 경기 둔화 우려로 원유 가격이 배럴당 $56.74까지 하락했습니다. 애널리스트들은 추가 하락 가능성을 경고하고 있습니다.',
        url: 'https://example.com/news/wti-oil-decline',
        source: 'CNBC',
        publishedAt: new Date('2026-01-24T10:15:00'),
        relatedCommodities: ['4', '5'], // WTI, Brent
        imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-4',
        title: '천연가스 가격 급등, 겨울 한파로 수요 폭증',
        summary: '북미와 유럽의 기록적 한파로 천연가스 수요가 급증하며 가격이 30% 이상 상승했습니다. 에너지 전문가들은 재고 부족 우려를 제기하고 있습니다.',
        url: 'https://example.com/news/natural-gas-winter-demand',
        source: 'Financial Times',
        publishedAt: new Date('2026-01-23T16:45:00'),
        relatedCommodities: ['14', '15'], // Natural Gas, Henry Hub
        imageUrl: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-5',
        title: '구리 가격 강세 지속, 친환경 에너지 전환 수혜',
        summary: '전기차와 재생에너지 인프라 구축 붐으로 구리 수요가 급증하고 있습니다. 주요 광산의 생산 차질로 공급 부족 우려가 확대되고 있습니다.',
        url: 'https://example.com/news/copper-green-energy',
        source: 'WSJ',
        publishedAt: new Date('2026-01-23T09:20:00'),
        relatedCommodities: ['copper'], // Copper (ID 확인 필요)
        imageUrl: 'https://images.unsplash.com/photo-1589254065878-42c9da997008?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-6',
        title: '밀 가격 하락세, 풍작 전망과 수요 감소',
        summary: '주요 생산국들의 밀 생산량 증가 전망과 글로벌 수요 둔화로 밀 선물 가격이 3개월 만에 최저치를 기록했습니다.',
        url: 'https://example.com/news/wheat-prices-decline',
        source: 'AgriNews',
        publishedAt: new Date('2026-01-22T11:00:00'),
        relatedCommodities: ['wheat'], // Wheat
        imageUrl: 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-7',
        title: '백금 시장 전망 개선, 수소 경제 성장 기대',
        summary: '수소 연료전지 기술 발전과 자동차 산업의 회복으로 백금 수요가 증가할 것으로 전망됩니다. 가격은 온스당 $1,150를 돌파했습니다.',
        url: 'https://example.com/news/platinum-hydrogen-economy',
        source: 'Metals Daily',
        publishedAt: new Date('2026-01-22T07:30:00'),
        relatedCommodities: ['3'], // Platinum
        imageUrl: 'https://images.unsplash.com/photo-1621259182978-fbf93132d53d?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-8',
        title: '커피 가격 급등, 기후 변화로 생산량 감소',
        summary: '주요 생산국인 브라질과 베트남의 가뭄으로 커피 생산량이 크게 감소하며 가격이 급등하고 있습니다. 소비자 가격 인상이 불가피할 전망입니다.',
        url: 'https://example.com/news/coffee-climate-crisis',
        source: 'Coffee World',
        publishedAt: new Date('2026-01-21T13:15:00'),
        relatedCommodities: ['coffee'],
        imageUrl: 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-9',
        title: '알루미늄 시장, 중국 생산 증가로 가격 압박',
        summary: '중국의 알루미늄 생산량이 전년 대비 15% 증가하면서 글로벌 가격에 하방 압력이 가해지고 있습니다. 과잉 공급 우려가 커지고 있습니다.',
        url: 'https://example.com/news/aluminum-china-production',
        source: 'Metal Bulletin',
        publishedAt: new Date('2026-01-20T15:30:00'),
        relatedCommodities: ['aluminum'],
        imageUrl: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-10',
        title: '리튬 가격 반등, 전기차 판매 회복 신호',
        summary: '글로벌 전기차 판매가 회복세를 보이면서 리튬 가격이 3개월 만에 처음으로 상승 전환했습니다. 배터리 제조사들의 재고 확보 움직임이 활발합니다.',
        url: 'https://example.com/news/lithium-ev-recovery',
        source: 'Battery Materials',
        publishedAt: new Date('2026-01-20T11:00:00'),
        relatedCommodities: ['lithium'],
        imageUrl: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-11',
        title: '옥수수 선물, 남미 풍작 전망에 약세',
        summary: '브라질과 아르헨티나의 옥수수 생산량이 예상을 상회할 것으로 전망되면서 시카고 옥수수 선물이 2주 연속 하락했습니다.',
        url: 'https://example.com/news/corn-south-america',
        source: 'AgriNews',
        publishedAt: new Date('2026-01-19T14:20:00'),
        relatedCommodities: ['corn'],
        imageUrl: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-12',
        title: '팔라듐 급등, 자동차 촉매 수요 증가',
        summary: '배출가스 규제 강화로 자동차 촉매 변환기 수요가 급증하면서 팔라듐 가격이 온스당 $1,200를 돌파했습니다.',
        url: 'https://example.com/news/palladium-auto-catalyst',
        source: 'PGM Insights',
        publishedAt: new Date('2026-01-19T09:45:00'),
        relatedCommodities: ['3'],
        imageUrl: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-13',
        title: '대두 가격 강세, 중국 수입 수요 확대',
        summary: '중국의 대두 수입량이 역대 최고치를 기록하면서 시카고 대두 선물이 3년 만에 최고가를 경신했습니다.',
        url: 'https://example.com/news/soybean-china-demand',
        source: 'Agri Markets',
        publishedAt: new Date('2026-01-18T16:00:00'),
        relatedCommodities: ['soybean'],
        imageUrl: 'https://images.unsplash.com/photo-1474440692490-2e83ae13ba29?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-14',
        title: '철광석 가격 하락, 중국 부동산 침체 영향',
        summary: '중국 부동산 시장의 지속적인 침체로 철광석 수요가 감소하며 가격이 톤당 $90 아래로 하락했습니다.',
        url: 'https://example.com/news/iron-ore-china-property',
        source: 'Steel Today',
        publishedAt: new Date('2026-01-18T10:30:00'),
        relatedCommodities: ['iron'],
        imageUrl: 'https://images.unsplash.com/photo-1565123409695-7b5ef51a1f3c?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-15',
        title: '설탕 시장 급등, 인도 수출 제한 조치',
        summary: '세계 2위 설탕 생산국인 인도가 수출 제한 조치를 단행하면서 글로벌 설탕 가격이 급등하고 있습니다.',
        url: 'https://example.com/news/sugar-india-export',
        source: 'Sweet Markets',
        publishedAt: new Date('2026-01-17T13:00:00'),
        relatedCommodities: ['sugar'],
        imageUrl: 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-16',
        title: '니켈 가격 변동성 확대, 인도네시아 정책 불확실성',
        summary: '인도네시아의 광물 수출 정책 변경 가능성으로 니켈 시장 변동성이 크게 확대되고 있습니다.',
        url: 'https://example.com/news/nickel-indonesia-policy',
        source: 'Battery Metals',
        publishedAt: new Date('2026-01-17T08:15:00'),
        relatedCommodities: ['nickel'],
        imageUrl: 'https://images.unsplash.com/photo-1618761714954-0b8cd0026356?w=800',
        sentiment: 'neutral'
    },
    {
        id: 'news-17',
        title: '원유 재고 급증, OPEC+ 감산 효과 제한적',
        summary: '미국 원유 재고가 예상을 크게 상회하며 증가하면서 OPEC+의 감산 효과가 제한적이라는 분석이 나오고 있습니다.',
        url: 'https://example.com/news/crude-inventory-opec',
        source: 'Energy Intelligence',
        publishedAt: new Date('2026-01-16T14:45:00'),
        relatedCommodities: ['4', '5'],
        imageUrl: 'https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-18',
        title: '코코아 가격 사상 최고치, 서아프리카 작황 부진',
        summary: '주요 생산지인 서아프리카의 코코아 작황 부진으로 가격이 톤당 $5,000를 돌파하며 사상 최고치를 경신했습니다.',
        url: 'https://example.com/news/cocoa-west-africa',
        source: 'Cocoa Markets',
        publishedAt: new Date('2026-01-16T11:20:00'),
        relatedCommodities: ['cocoa'],
        imageUrl: 'https://images.unsplash.com/photo-1511381939415-e44015466834?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-19',
        title: '아연 시장 타이트, 광산 폐쇄 및 수요 증가',
        summary: '주요 광산의 폐쇄와 아연 도금 수요 증가로 시장이 타이트해지면서 가격이 급등하고 있습니다.',
        url: 'https://example.com/news/zinc-supply-tight',
        source: 'Zinc Weekly',
        publishedAt: new Date('2026-01-15T15:30:00'),
        relatedCommodities: ['zinc'],
        imageUrl: 'https://images.unsplash.com/photo-1565123409695-7b5ef51a1f3c?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-20',
        title: '팜유 가격 하락, 인도네시아 생산 증가',
        summary: '세계 최대 팜유 생산국 인도네시아의 생산량 증가로 가격이 톤당 $900 아래로 하락했습니다.',
        url: 'https://example.com/news/palm-oil-production',
        source: 'Oils & Fats',
        publishedAt: new Date('2026-01-15T09:00:00'),
        relatedCommodities: ['palm-oil'],
        imageUrl: 'https://images.unsplash.com/photo-1615485500834-bc10199bc727?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-21',
        title: '금 ETF 자금 유입 급증, 안전자산 선호 강화',
        summary: '지정학적 불확실성 확대로 금 ETF로의 자금 유입이 월간 기준 역대 최대를 기록했습니다.',
        url: 'https://example.com/news/gold-etf-inflow',
        source: 'ETF Daily',
        publishedAt: new Date('2026-01-14T10:30:00'),
        relatedCommodities: ['1'],
        imageUrl: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-22',
        title: 'LNG 가격 급등, 유럽 에너지 위기 재점화',
        summary: '러시아 가스 공급 중단 우려로 유럽 LNG 가격이 급등하며 에너지 위기 재점화 우려가 커지고 있습니다.',
        url: 'https://example.com/news/lng-europe-crisis',
        source: 'Gas Markets',
        publishedAt: new Date('2026-01-14T07:15:00'),
        relatedCommodities: ['18', '19'],
        imageUrl: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-23',
        title: '은행들, 2026년 금 가격 전망 상향 조정',
        summary: '골드만삭스, JP모건 등 주요 투자은행들이 금 가격 전망치를 온스당 $4,800-5,000로 상향 조정했습니다.',
        url: 'https://example.com/news/banks-gold-forecast',
        source: 'Investment Bank',
        publishedAt: new Date('2026-01-13T14:00:00'),
        relatedCommodities: ['1'],
        imageUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-24',
        title: '면화 가격 약세, 세계 수요 둔화',
        summary: '글로벌 경기 둔화로 섬유 수요가 감소하면서 면화 선물 가격이 2년 만에 최저치로 하락했습니다.',
        url: 'https://example.com/news/cotton-demand-weak',
        source: 'Textile Today',
        publishedAt: new Date('2026-01-13T11:45:00'),
        relatedCommodities: ['cotton'],
        imageUrl: 'https://images.unsplash.com/photo-1535639818669-c059d2f038e6?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-25',
        title: '구리 재고 급감, 공급 부족 심화',
        summary: 'LME 구리 재고가 10년 만에 최저 수준으로 감소하며 공급 부족 우려가 심화되고 있습니다.',
        url: 'https://example.com/news/copper-inventory-low',
        source: 'LME Watch',
        publishedAt: new Date('2026-01-12T16:20:00'),
        relatedCommodities: ['copper'],
        imageUrl: 'https://images.unsplash.com/photo-1589254066213-a0c9dc853511?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-26',
        title: '석탄 가격 하락, 재생에너지 전환 가속화',
        summary: '재생에너지로의 전환이 가속화되면서 석탄 수요가 감소하고 가격이 톤당 $100 아래로 하락했습니다.',
        url: 'https://example.com/news/coal-renewable-shift',
        source: 'Energy Transition',
        publishedAt: new Date('2026-01-12T08:30:00'),
        relatedCommodities: ['coal'],
        imageUrl: 'https://images.unsplash.com/photo-1548613053-22087dd8edb8?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-27',
        title: '쌀 가격 급등, 인도 수출 금지 조치',
        summary: '세계 최대 쌀 수출국 인도의 수출 금지 조치로 글로벌 쌀 가격이 급등하고 있습니다.',
        url: 'https://example.com/news/rice-india-ban',
        source: 'Rice Market',
        publishedAt: new Date('2026-01-11T13:00:00'),
        relatedCommodities: ['rice'],
        imageUrl: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-28',
        title: '브렌트유-WTI 스프레드 확대, 공급 구조 변화',
        summary: '중동 지정학적 리스크 증가로 브렌트유와 WTI 간 가격 차이가 배럴당 $5 이상으로 확대되었습니다.',
        url: 'https://example.com/news/brent-wti-spread',
        source: 'Oil Analytics',
        publishedAt: new Date('2026-01-11T10:15:00'),
        relatedCommodities: ['4', '5'],
        imageUrl: 'https://images.unsplash.com/photo-1545262810-77515befe149?w=800',
        sentiment: 'neutral'
    },
    {
        id: 'news-29',
        title: '로듐 가격 폭등, 공급 부족 심각',
        summary: '자동차 촉매 변환기에 필수적인 로듐의 공급 부족이 심각해지면서 가격이 온스당 $6,000를 돌파했습니다.',
        url: 'https://example.com/news/rhodium-shortage',
        source: 'PGM Markets',
        publishedAt: new Date('2026-01-10T14:30:00'),
        relatedCommodities: ['rhodium'],
        imageUrl: 'https://images.unsplash.com/photo-1565123409695-7b5ef51a1f3c?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-30',
        title: '우라늄 시장 강세, 원전 재가동 움직임',
        summary: '탄소중립 달성을 위한 원전 재가동 움직임이 확산되면서 우라늄 가격이 파운드당 $90를 돌파했습니다.',
        url: 'https://example.com/news/uranium-nuclear-restart',
        source: 'Nuclear Energy',
        publishedAt: new Date('2026-01-10T09:00:00'),
        relatedCommodities: ['uranium'],
        imageUrl: 'https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-31',
        title: '주석 가격 급등, 반도체 수요 증가',
        summary: '반도체 산업의 회복세와 함께 납땜재 수요가 증가하면서 주석 가격이 톤당 $30,000를 돌파했습니다.',
        url: 'https://example.com/news/tin-semiconductor',
        source: 'Minor Metals',
        publishedAt: new Date('2026-01-09T15:20:00'),
        relatedCommodities: ['tin'],
        imageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-32',
        title: '고무 가격 약세, 자동차 생산 감소',
        summary: '글로벌 자동차 생산 둔화로 천연고무 수요가 감소하며 가격이 kg당 $1.50 아래로 하락했습니다.',
        url: 'https://example.com/news/rubber-auto-slowdown',
        source: 'Rubber Weekly',
        publishedAt: new Date('2026-01-09T11:00:00'),
        relatedCommodities: ['rubber'],
        imageUrl: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-33',
        title: '희토류 가격 급등, 중국 수출 통제 강화',
        summary: '중국이 희토류 수출 통제를 강화하면서 네오디뮴, 디스프로슘 등 가격이 급등하고 있습니다.',
        url: 'https://example.com/news/rare-earth-china',
        source: 'Rare Earth Today',
        publishedAt: new Date('2026-01-08T13:45:00'),
        relatedCommodities: ['rare-earth'],
        imageUrl: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-34',
        title: '헤지펀드, 원자재 매수 포지션 확대',
        summary: '주요 헤지펀드들이 인플레이션 헤지 목적으로 원자재 매수 포지션을 대폭 확대하고 있습니다.',
        url: 'https://example.com/news/hedge-fund-commodities',
        source: 'Hedge Fund Weekly',
        publishedAt: new Date('2026-01-08T10:30:00'),
        relatedCommodities: ['1', '2', 'copper'],
        imageUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-35',
        title: '바나듐 시장 강세, 에너지 저장 수요',
        summary: '대규모 에너지 저장 시스템(ESS) 구축으로 바나듐 레독스 배터리 수요가 급증하고 있습니다.',
        url: 'https://example.com/news/vanadium-energy-storage',
        source: 'Battery Materials',
        publishedAt: new Date('2026-01-07T14:00:00'),
        relatedCommodities: ['vanadium'],
        imageUrl: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-36',
        title: '캐시미어 원단 가격 급등, 몽골 공급 감소',
        summary: '몽골의 기후 변화로 캐시미어 원모 생산량이 감소하며 가격이 kg당 $80를 돌파했습니다.',
        url: 'https://example.com/news/cashmere-mongolia',
        source: 'Luxury Textiles',
        publishedAt: new Date('2026-01-07T09:15:00'),
        relatedCommodities: ['cashmere'],
        imageUrl: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-37',
        title: '오렌지 주스 선물 급등, 플로리다 한파 피해',
        summary: '플로리다의 기록적 한파로 오렌지 작황이 크게 악화되면서 주스 선물 가격이 급등하고 있습니다.',
        url: 'https://example.com/news/orange-juice-florida',
        source: 'Citrus Report',
        publishedAt: new Date('2026-01-06T11:30:00'),
        relatedCommodities: ['orange-juice'],
        imageUrl: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-38',
        title: '코발트 가격 하락, 전기차 배터리 기술 변화',
        summary: 'LFP 배터리 채택 확대로 코발트 수요 감소 우려가 커지며 가격이 파운드당 $15 아래로 하락했습니다.',
        url: 'https://example.com/news/cobalt-lfp-battery',
        source: 'Battery Tech',
        publishedAt: new Date('2026-01-06T08:00:00'),
        relatedCommodities: ['cobalt'],
        imageUrl: 'https://images.unsplash.com/photo-1625474038293-f9c78e76e3cf?w=800',
        sentiment: 'negative'
    },
    {
        id: 'news-39',
        title: '망간 시장 주목, 차세대 배터리 핵심 소재',
        summary: '고망간 배터리 개발 가속화로 망간이 차세대 배터리 핵심 소재로 주목받으며 가격이 상승하고 있습니다.',
        url: 'https://example.com/news/manganese-battery',
        source: 'Mining Weekly',
        publishedAt: new Date('2026-01-05T15:00:00'),
        relatedCommodities: ['manganese'],
        imageUrl: 'https://images.unsplash.com/photo-1530587191325-3db32d826c18?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-40',
        title: '돼지고기 선물 급등, 아프리카돼지열병 확산',
        summary: '아시아 지역의 아프리카돼지열병 재확산으로 돼지고기 공급 부족 우려가 커지며 가격이 급등하고 있습니다.',
        url: 'https://example.com/news/pork-asf-spread',
        source: 'Livestock Markets',
        publishedAt: new Date('2026-01-05T10:45:00'),
        relatedCommodities: ['pork'],
        imageUrl: 'https://images.unsplash.com/photo-1560781290-7dc94c0f8f4f?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-41',
        title: '그래핀 시장 성장 가속, 상용화 본격화',
        summary: '그래핀의 상용화가 본격화되면서 관련 원료 수요가 급증하고 시장 규모가 빠르게 성장하고 있습니다.',
        url: 'https://example.com/news/graphene-commercialization',
        source: 'Advanced Materials',
        publishedAt: new Date('2026-01-04T13:20:00'),
        relatedCommodities: ['graphene'],
        imageUrl: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-42',
        title: 'IMF, 2026년 원자재 가격 전망 발표',
        summary: 'IMF가 2026년 원자재 가격이 평균 8% 상승할 것으로 전망하며 인플레이션 압력 지속을 경고했습니다.',
        url: 'https://example.com/news/imf-commodity-outlook',
        source: 'IMF Report',
        publishedAt: new Date('2026-01-04T07:00:00'),
        relatedCommodities: ['1', '4', 'copper'],
        imageUrl: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800',
        sentiment: 'neutral'
    },
    {
        id: 'news-43',
        title: '크롬 가격 상승, 스테인리스 수요 증가',
        summary: '글로벌 스테인리스 스틸 생산 증가로 크롬 수요가 확대되면서 가격이 톤당 $9,000를 돌파했습니다.',
        url: 'https://example.com/news/chrome-stainless-demand',
        source: 'Ferro Alloys',
        publishedAt: new Date('2026-01-03T14:30:00'),
        relatedCommodities: ['chrome'],
        imageUrl: 'https://images.unsplash.com/photo-1565123409695-7b5ef51a1f3c?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-44',
        title: '월가, 2026년 원자재 슈퍼사이클 전망',
        summary: '월스트리트 애널리스트들이 공급 제약과 수요 증가로 원자재 슈퍼사이클이 시작될 것으로 전망하고 있습니다.',
        url: 'https://example.com/news/wall-street-super-cycle',
        source: 'Wall Street Journal',
        publishedAt: new Date('2026-01-03T09:00:00'),
        relatedCommodities: ['1', '2', 'copper'],
        imageUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-45',
        title: '수소 경제 확대, 백금족 금속 수요 증가 전망',
        summary: '수소 연료전지 보급 확대로 백금, 팔라듐 등 백금족 금속 수요가 향후 5년간 50% 이상 증가할 전망입니다.',
        url: 'https://example.com/news/hydrogen-pgm-demand',
        source: 'Hydrogen Economy',
        publishedAt: new Date('2026-01-02T11:15:00'),
        relatedCommodities: ['3'],
        imageUrl: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-46',
        title: '암모니아 가격 급등, 비료 수요 폭증',
        summary: '세계 식량 위기 우려로 비료 수요가 폭증하면서 암모니아 가격이 톤당 $800를 돌파했습니다.',
        url: 'https://example.com/news/ammonia-fertilizer',
        source: 'Fertilizer Week',
        publishedAt: new Date('2026-01-02T08:30:00'),
        relatedCommodities: ['ammonia'],
        imageUrl: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-47',
        title: '2026년 금 수요, 중앙은행 매입 주도 전망',
        summary: '세계금협회가 2026년 중앙은행들의 금 매입이 전년 대비 15% 증가할 것으로 전망했습니다.',
        url: 'https://example.com/news/gold-central-bank-2026',
        source: 'World Gold Council',
        publishedAt: new Date('2026-01-01T10:00:00'),
        relatedCommodities: ['1'],
        imageUrl: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-48',
        title: '중국, 전략 비축 확대로 원자재 대량 매집',
        summary: '중국 정부가 전략 비축 확대 계획의 일환으로 구리, 알루미늄, 원유 등을 대량 매집하고 있습니다.',
        url: 'https://example.com/news/china-strategic-reserve',
        source: 'China Commodities',
        publishedAt: new Date('2025-12-31T14:00:00'),
        relatedCommodities: ['copper', '4'],
        imageUrl: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800',
        sentiment: 'positive'
    },
    {
        id: 'news-50',
        title: '기후 변화가 원자재 시장에 미치는 영향 심화',
        summary: '전문가들이 기후 변화로 인한 극한 기후가 원자재 생산과 가격에 미치는 영향이 점점 커지고 있다고 경고했습니다.',
        url: 'https://example.com/news/climate-commodities-impact',
        source: 'Climate & Markets',
        publishedAt: new Date('2025-12-30T09:00:00'),
        relatedCommodities: ['1', 'wheat', 'coffee'],
        imageUrl: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800',
        sentiment: 'neutral'
    }
];
